import React from 'react';
import {
  TablePagination
} from '@material-ui/core';
import { useEpDevPSearch } from '../../context';
import { EpDevPSearchInitialPageSize } from '../../context/EpDevPSearchContext';
import { useServiceRegistryTranslation } from '../../../../../i18n/ServiceRegistryLanguageProvider';
import { displayedRowsLabel } from '../../../../../i18n/pagination';

export type EpDevPSearchPaginationProps = {
}
export const EpDevPSearchPagination = (_props: EpDevPSearchPaginationProps) => {
  const { t } = useServiceRegistryTranslation();

  const { setPageNumber, setPageSize, result } = useEpDevPSearch();

  const rowsPerPageOptions = [EpDevPSearchInitialPageSize, 25, 50, 100];

  const [rowsPerPage, setRowsPerPage] = React.useState<number>(rowsPerPageOptions[0]);

  const handlePageChange = React.useCallback((_: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPageNumber(newPage + 1);
  }, [setPageNumber]);

  const handleRowsPerPageChange = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const newValue = e.target.value;
    const newRowsPerPage = parseInt(newValue, 10);
    setRowsPerPage(newRowsPerPage);
    setPageSize(newRowsPerPage);
  }, [setRowsPerPage, setPageSize]);

  if (result.value === undefined) return (<></>);

  const count = result.value.meta.pagination.count;
  const page = result.value.meta.pagination.pageNumber - 1;

  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={handlePageChange}
      rowsPerPage={rowsPerPage}
      labelRowsPerPage={t('pagination.rows')}
      labelDisplayedRows={values => displayedRowsLabel(t, values)}
      onRowsPerPageChange={handleRowsPerPageChange}
    />
  );
}
